// extracted by mini-css-extract-plugin
export default {"text":"RequestEntityButton_text__+TZTa","button":"RequestEntityButton_button__k3lyC"};